import {decodeJson} from "@2d-front-monorepo/core";
import ICustomData from "./interfaces/ICustomData.js";
import {PermitId} from "./nominalTypes/PermitId";

function getCustomDataIndex(customData: ICustomData, key: string): number {
	let cd = customData.customData;
	let total = cd.length;
	let lowerKey = key.toLowerCase();
	for (let index = 0; index < total; ++index) {
		if (cd[index].key.toLowerCase() === lowerKey) {
			return index;
		}
	}
	return -1;
}

const CUSTOM_NOTES: string = "custom-notes";
const PARENT_PERMIT_ID_KEY: string = "::parent-permit-id";
const GROUP_NAME_KEY: string = "::group-name";
const OPERATION_IDS: string = "::operation-ids";
const MULTI_OPERATION:string = "::multiple-operations";

class CustomData {
	static containsKey(customData: ICustomData, key: string): boolean {
		return getCustomDataIndex(customData, key) >= 0;
	}

	static get(customData: ICustomData, key: string): string | undefined {
		const index = getCustomDataIndex(customData, key);
		return index >= 0 ? customData.customData[index].value : undefined;
	}

	static isMultiOperation(customData: ICustomData): boolean {
		return this.containsKey(customData, MULTI_OPERATION);
	}

	static getGroupName(customData: ICustomData): string | undefined {
		return this.get(customData, GROUP_NAME_KEY);
	}

	static getNotes(customData: ICustomData): string | undefined {
		return this.get(customData, CUSTOM_NOTES);
	}

	static getObject<T>(customData: ICustomData, key: string): T | undefined {
		const value = this.get(customData, key);
		if (value == null) return undefined;
		return decodeJson<T>(value);
	}

	static getParentPermitId(customData: ICustomData): PermitId | undefined {
		return this.get(customData, PARENT_PERMIT_ID_KEY) as PermitId;
	}

	static remove(customData: ICustomData, key: string): void {
		const index = getCustomDataIndex(customData, key);
		if (index === -1) {
			return;
		}
		customData.customData.splice(index, 1);
	}

	static set(customData: ICustomData, key: string, value: string): void {
		const index = getCustomDataIndex(customData, key);
		if (index >= 0) {
			customData.customData[index].value = value;
		} else {
			customData.customData.push({key, value: value});
		}
	}

	static setNotes(customData: ICustomData, notes: string): void {
		this.set(customData, CUSTOM_NOTES, notes);
	}

	static setObject<T>(customData: ICustomData, key: string, value: T): void {
		const index = getCustomDataIndex(customData, key);
		const json = JSON.stringify(value);
		if (index >= 0) {
			customData.customData[index].value = json;
		} else {
			customData.customData.push({key, value: json});
		}
	}

	static setParentPermitId(customData: ICustomData, parentId: PermitId): void {
		this.set(customData, PARENT_PERMIT_ID_KEY, parentId);
	}
}

export {CustomData};
